import jwt_decode from 'jwt-decode';
import { CUSTOMER_ROLES } from '../constants/roles';
import { Routes } from '../constants/routes';

/**
 * ALWYAS interrogate the user's current access token to check if they're still
 * logged in, because it could have expired or been modified.  Do not store a
 * snapshot of a user's loggedIn status in Redux, because it can become out of
 * date and thus inaccurate.
 * 
 * @param {*} reduxUser 
 */
export const isLoggedIn = (reduxUser) => {
    if (reduxUser && reduxUser.accessToken) {
        const jwt = jwt_decode(reduxUser.accessToken);
        if (!jwt) { 
            return false;
        }

        const current_time = Date.now().valueOf() / 1000;
        const isExpired = (jwt && jwt.exp && jwt.exp < current_time);
        const isBeforeTokenIssuanceTime = (jwt && jwt.nbf && jwt.nbf >= current_time);

        /**
         * Intentionally lenient: a merely-expired access token is still treated as
         * "logged in" so the app keeps rendering and the token is refreshed silently
         * on the next request (401 → refreshAccessToken → retry, see helpers/api.js
         * and helpers/pacerApi.ts). Access tokens are short-lived (15 min web, 60 s
         * SSO) while the refresh token lives much longer, so an expired access token
         * is the normal steady state between refreshes — NOT a reason to bounce a
         * valid session to the login page.
         *
         * Do NOT change this to `||`. Doing so redirects to /login the instant the
         * access token expires (verified in-browser: expired AT + valid RT → login
         * page instead of a silent refresh), logging users out every 15 min / 60 s.
         * A genuinely dead session (refresh also failed) is handled where it belongs:
         * the refresh path dispatches LOGOUT_SUCCESS, which clears the token, and THAT
         * makes isLoggedIn return false (no accessToken) → clean redirect.
         *
         * `&&` here is effectively "has a token": it only rejects the impossible
         * expired-and-not-yet-valid combination, which is fine.
         */
        if (isExpired && isBeforeTokenIssuanceTime) {
            return false;
        }

        return true;
    }
    return false;
}

export const getTokenExp = (reduxUser) => {
    if(reduxUser && reduxUser.accessToken) {
        const jwt = jwt_decode(reduxUser.accessToken);
        if (!jwt) { 
            return 0;
        }
        return jwt.exp;
    } else {
        return 0;
    }
}

export const getRedirectLocation = (customerRoleName, hasMultipleLocations) => {
    if(customerRoleName === CUSTOMER_ROLES.User.name || !hasMultipleLocations){
        return Routes.DashboardLocation;
    } else {
        return Routes.DashboardCorporate;
    }
}

export const isRegularUser = (roleName) => {
    return ![CUSTOMER_ROLES.Admin.name, CUSTOMER_ROLES.Moderator.name, CUSTOMER_ROLES.Owner.name].includes(roleName);
}

export const isCustomerAdminOrOwner = (roleName) => {
    return [CUSTOMER_ROLES.Admin.name, CUSTOMER_ROLES.Owner.name].includes(roleName);
}
